import { isAfter, isBefore, isSameDay } from 'date-fns';
const groupByTool = (filteredData) => {
    let reportData = [];
    filteredData.forEach((data) => {
        let { media, toolName, spend, impressions } = data;
        let toolIdx = reportData.findIndex((item) => item.toolName === data.toolName);
        if (toolIdx > -1) {
            reportData[toolIdx].spend += spend;
            reportData[toolIdx].impressions += impressions;
            if (!reportData[toolIdx].medias.includes(media))
                reportData[toolIdx].medias.push(media);
        }
        else
            reportData.push({
                medias: [media],
                spend,
                toolName,
                impressions,
            });
    });
    return reportData;
};
const groupByMediaOption = (filteredData) => {
    let reportData = [];
    filteredData.forEach((data) => {
        let { mediaOption, media, spend, impressions } = data;
        let mediaOptionIdx = reportData.findIndex((item) => item.mediaOption === data.mediaOption && item.media === data.media);
        if (mediaOptionIdx > -1) {
            reportData[mediaOptionIdx].spend += spend;
            reportData[mediaOptionIdx].impressions += impressions;
        }
        else {
            reportData.push({ mediaOption, spend, impressions, media });
        }
    });
    return reportData;
};
export const getFilteredAnalyticsData = (data, groupBy, duration) => {
    let filteredData = [...data];
    if ((duration === null || duration === void 0 ? void 0 : duration.from) && (duration === null || duration === void 0 ? void 0 : duration.to))
        filteredData = filteredData.filter((data) => (isAfter(new Date(data.date), new Date(duration.from)) &&
            isBefore(new Date(data.date), new Date(duration.to))) ||
            isSameDay(new Date(data.date), new Date(duration.from)) ||
            isSameDay(new Date(data.date), new Date(duration.to)));
    switch (groupBy) {
        case 'toolName':
            return groupByTool(filteredData);
        case 'mediaOption':
            return groupByMediaOption(filteredData);
    }
};
